const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const OrderPrioQuery: any = {
    GetOrderPrioList: Backofficebff + '/v1/postcheckout/get-order-priority-list',
    GetOrderPrioTypes: Backofficebff + '/v1/postcheckout/get-order-priority-types',
    GetOrderPrioReasons: Backofficebff + '/v1/postcheckout/get-order-priority-reasons',
};
